import { Component, inject } from '@angular/core';
import { AppVersionService } from '../../../core/services/app-version.service';
import { ButtonComponent } from '../button/button.component';
import { TextComponent } from '../typography/text/text.component';
import { LucideIconComponent } from '../lucide-icon/lucide-icon.component';

@Component({
  selector: 'app-update-banner',
  standalone: true,
  imports: [ButtonComponent, TextComponent, LucideIconComponent],
  template: `
    @if (versionService.showUpdateBanner()) {
      <div
        role="status"
        aria-live="polite"
        animate.enter="hv-float-bar-enter"
        animate.leave="hv-float-bar-leave"
        class="fixed bottom-5 left-1/2 -translate-x-1/2 z-[100] w-[calc(100vw-2rem)] sm:w-auto max-w-lg"
      >
        <div
          class="flex items-center gap-3.5 px-4 py-3 rounded-2xl bg-surface border-2 border-primary shadow-2xl"
        >
          <div class="relative flex items-center justify-center w-9 h-9 rounded-xl bg-primary text-primary-foreground shrink-0 shadow-sm">
            <lucide-icon name="Sparkles" [size]="18" />
            <span class="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-accent border-2 border-surface animate-pulse"></span>
          </div>
          <div class="flex-1 min-w-0 pr-1">
            <app-text size="sm" weight="semibold" class="text-foreground block leading-snug">
              A new version of Haulverse is ready
            </app-text>
            <app-text size="xs" class="text-muted block leading-snug mt-0.5">
              Refresh now for the latest improvements, or switch pages to auto-update.
            </app-text>
          </div>
          <div class="flex items-center gap-1.5 shrink-0">
            <app-button
              size="sm"
              variant="primary"
              shape="pill"
              icon="RefreshCw"
              [loading]="versionService.isUpdating()"
              [disabled]="versionService.isUpdating()"
              (click)="versionService.applyUpdateNow()"
            >
              {{ versionService.isUpdating() ? 'Updating...' : 'Update now' }}
            </app-button>
            <app-button
              size="sm"
              variant="ghost"
              shape="circle"
              [iconOnly]="true"
              icon="X"
              title="Dismiss"
              (click)="versionService.dismissBanner()"
            />
          </div>
        </div>
      </div>
    }
  `,
})
export class AppUpdateBannerComponent {
  protected readonly versionService = inject(AppVersionService);
}
